import { IGrowthModelApiService } from '../../../api/services/growth-model-api-service';
import { GrowthModelWorkbook } from '../../../models/growth-model/growth-model';

export async function loadGrowthModelForBoot(
	api: Pick<IGrowthModelApiService, 'getModel'>
): Promise<{ workbook: GrowthModelWorkbook; bindSource: string }> {
	const workbook = await api.getModel();
	if (!workbook.months?.length) {
		throw new Error('Growth Model returned an empty workbook');
	}
	const bindSource = String(workbook.bindSource || '').trim() || 'none';
	return { workbook, bindSource };
}
